export default __webpack_public_path__ + "2b601c01830fbc9ca1c84365bcafcbaf.svg";